import axios from "axios";
import * as config from "../../config";
import UserProfile from '../../UserProfile';

export function getRegion() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/region', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function searchTerritory(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/search/territory?rID=' + data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function searchSaleAndStore(tID, rID) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/search/sale_store?tID=' + tID +'&rID=' + rID, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function reportWeb(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlAPI + '/report/attendence', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function reportExcel(data) {

    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    let options = {
        responseType: 'blob',
        authorization
    }
    return axios.get(config.urlAPI + '/report/attendence/excel?rID=' + data.rID + '&saleAreaCd=' + data.saleAreaCd + '&storeID=' + data.storeID + '&saleID=' + data.saleID + '&startDate=' + data.startDate + '&endDate=' + data.endDate, options)
        // .then(downloadErrorDetailBlastSuccess())
        .then(res => {
            // return res
            downloadErrorDetailBlastSuccess(res, data)
        })
    // .catch(downloadErrorDetailBlastFailure())
}
const downloadErrorDetailBlastSuccess = (response, data) => {

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
    const link = document.createElement('a');

    link.href = url;
    // link.setAttribute('download', 'ReportSale_'+data.regionSelected+'_'+data.territorySelected+'_'+data.startDate+'_'+data.endDate+'.xls');
    link.setAttribute('download', data.regionSelected+'_'+data.territorySelected+'_'+data.startDate+'_'+data.endDate+'.xls');
    document.body.appendChild(link);
    link.click();
    // console.log(response.data)
    // alert("File Berhasil Didownload!")

}


    // return axios.get(config.urlAPI + '/report/attendence/excel?rID=' + data.rID + '& saleAreaCd=' + data.saleAreaCd + '& storeID=' + data.storeID + '& saleID=' + data.saleID + '& startDate=' + data.startDate + '& endDate=' + data.endDate, options)
    //     .then(res => {
    //         return res
    //     }).catch((error) => {
    //         // Error
    //         if (error.response) {
    //             // The request was made and the server responded with a status code
    //             // that falls out of the range of 2xx
    //             console.log(error.response.data);
    //             // console.log(error.response.status);
    //             // console.log(error.response.headers);
    //             return error.response.data.message
    //         } else if (error.request) {
    //             // The request was made but no response was received
    //             // `error.request` is an instance of XMLHttpRequest in the 
    //             // browser and an instance of
    //             // http.ClientRequest in node.js
    //             console.log(error.request);
    //         } else {
    //             // Something happened in setting up the request that triggered an Error
    //             console.log('Error', error.message);
    //         }
    //         console.log(error.config);
    //     });
// }
